import { Helmet } from 'react-helmet-async';

export default function Page() {
  return (
    <>
      {/* SEO Metadata */}
<Helmet>
        <title>About Us - Acme Corporation</title>
        <meta name="description" content="test description" />
      </Helmet>
      
      {/* Page Content */}

    </>
  );
}
